import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  PaginationParameters,
  InitialPaginationParameters,
} from '../../common/types/pagination.types';
import {
  getAuditLogsAsync,
  selectAuditLogItems,
  selectAuditLogItemsLoadingStatus,
  selectAuditLogsPagination,
} from './auditLogsSlice';
import {
  DataTable,
  DataTableItem,
  Loader,
  PaginationComponent,
  SectionHeader,
} from '../../common/components';

import { LOADING_STATUS } from '../../common/constants';

function AuditLogs() {
  const dispatch = useAppDispatch();
  const auditLogItems = useAppSelector(selectAuditLogItems);
  const auditLogItemsLoadingStatus = useAppSelector(
    selectAuditLogItemsLoadingStatus,
  );
  const auditLogItemsPagination = useAppSelector(selectAuditLogsPagination);

  const initialAuditLogsFilter: PaginationParameters = {
    PageNumber: InitialPaginationParameters.PageNumber,
    PageSize: InitialPaginationParameters.PageSize,
  };

  const [auditLogsFilters, setAuditLogsFilters] = useState(
    initialAuditLogsFilter,
  );

  const [auditLogItemsList, setAuditLogItemsList] = useState<DataTableItem[]>(
    [],
  );

  const doSearch = () => {
    const searchFilters: PaginationParameters = auditLogsFilters;
    dispatch(getAuditLogsAsync(searchFilters));
  };

  const HandlePaginationClick = (Page: number) => {
    const searchFilters: PaginationParameters = auditLogsFilters;
    searchFilters.PageNumber = Page;
    setAuditLogsFilters(searchFilters);
    doSearch();
  };

  useEffect(() => {
    doSearch();
  }, []);

  useEffect(() => {
    if (
      auditLogItems &&
      auditLogItems !== 'undefined' &&
      auditLogItems.length > 0
    ) {
      const formattedAuditLogList: DataTableItem[] = [];
      auditLogItems?.forEach(item => {
        formattedAuditLogList.push({
          ItemId: item.id,
          Items: [item.id, item.messageType, item.userId, item.email],
        });
      });
      setAuditLogItemsList(formattedAuditLogList);
    }
  }, [auditLogItems]);

  return (
    <>
      <Helmet>
        <title>Asetukset - Lokitiedot</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader Breadcrumbs={['Asetukset']} Title="Lokitiedot" />
        <Loader
          IsLoading={auditLogItemsLoadingStatus === LOADING_STATUS.LOADING}
        />
        {auditLogItemsLoadingStatus === LOADING_STATUS.IDLE &&
          auditLogItemsList.length > 0 && (
            <>
              <DataTable
                Header={['EventID', 'Tyyppi', 'UserID', 'Email']}
                IsHoverable={false}
                Items={auditLogItemsList}
                LegendText="lokitietoa"
              />
              <PaginationComponent
                OnPageClick={HandlePaginationClick}
                PaginationData={auditLogItemsPagination}
              />
            </>
          )}
        {auditLogItemsLoadingStatus === LOADING_STATUS.IDLE &&
          auditLogItemsList.length < 1 && <p>Ei lokitietoja.</p>}
      </Container>
    </>
  );
}

export default AuditLogs;
